import { post } from '@/utils/examMan/request'

/**
 * 题库详情
 * @param data
 */
export function fetchDetail(id) {
  return post('/api/learn/api/exam/exam/detail', { id: id })
}

/**
 * 简略详情
 * @param data
 */
export function simpleDetail(id) {
  return post('/api/learn/api/exam/exam/simple-detail', { id: id })
}

/**
 * 保存题库
 * @param data
 */
export function saveData(data) {
  return post('/api/learn/api/exam/exam/save', data)
}

/**
 * 题库详情
 * @param data
 */
export function fetchList(data) {
  return post('/api/learn/api/exam/exam/paging', data)
}

/**
 * 校验考试信息
 * @param id
 * @returns {*}
 */
export function checkInfo(id) {
  return post('/api/learn/api/exam/exam/check-info', { id: id })
}

/**
 * 发送考试安排
 * @param data
 * @returns {Promise}
 */
export function prepareNotify(data) {
  return post('/api/learn/api/exam/exam/prepare-notify', data)
}

/**
 * 创建预付费订单
 * @param id
 * @returns {Promise}
 */
export function buy(examId) {
  return post('/api/learn/api/exam/buy/init', { examId: examId })
}

/**
 * 根据考试ID列表获得考试标题
 * @param data
 * @returns {Promise}
 */
export function listTitles(data) {
  return post('/api/learn/api/exam/exam/list-titles', data)
}


